export default __webpack_public_path__ + "static/media/6_School of animals.1e36d51f.jpg";